import React from 'react';

// ── ResizeHandle ─────────────────────────────────────────────────────
// Drag strip on a panel boundary. `axis` is 'x' (col-resize), 'y'
// (row-resize) or 'both' (corner). The parent captures its starting size in
// `onStart` and applies `onResize(dx, dy)` — total pointer movement since
// the drag began. `style` positions it (absolute overlays or flex). No
// visible icon — the resize cursor and a faint hover highlight are the cue.
export function ResizeHandle({ axis = 'x', onStart, onResize, onEnd, style }) {
  const [active, setActive] = React.useState(false);
  const [hover, setHover] = React.useState(false);
  const cursor = axis === 'x' ? 'col-resize' : axis === 'y' ? 'row-resize' : 'nwse-resize';

  const onDown = (e) => {
    if (e.button !== 0) return;
    e.preventDefault();
    e.stopPropagation();
    const sx = e.clientX, sy = e.clientY;
    onStart?.();
    setActive(true);
    const prevCursor = document.body.style.cursor;
    const prevSelect = document.body.style.userSelect;
    document.body.style.cursor = cursor;
    document.body.style.userSelect = 'none';
    const move = (ev) => onResize?.(ev.clientX - sx, ev.clientY - sy);
    const up = () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseup', up);
      document.body.style.cursor = prevCursor;
      document.body.style.userSelect = prevSelect;
      setActive(false);
      onEnd?.();
    };
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
  };

  const lit = active || hover;
  return (
    <div
      onMouseDown={onDown}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={(e) => e.stopPropagation()}
      title="Drag to resize"
      style={{
        position: 'relative', flexShrink: 0, cursor, zIndex: 5,
        ...(axis === 'x' ? { width: 8 } : axis === 'y' ? { height: 8 } : { width: 16, height: 16 }),
        background: lit && axis !== 'both' ? 'var(--info-bg)' : 'transparent',
        transition: 'background-color .12s',
        ...style,
      }}
    >
    </div>
  );
}
